"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@8base/utils");
const web_auth0_auth_client_1 = require("@8base/web-auth0-auth-client");
const web_cognito_auth_client_1 = require("@8base/web-cognito-auth-client");
const web_oauth_client_1 = require("@8base/web-oauth-client");
const api_token_auth_client_1 = require("@8base/api-token-auth-client");
const constants_1 = require("./constants");
const SubscribableDecorator_1 = require("./SubscribableDecorator");
const getAuthClientConstructor = (strategy) => {
    switch (strategy) {
        case constants_1.AUTH_STRATEGIES.API_TOKEN: {
            return api_token_auth_client_1.ApiTokenAuthClient;
        }
        case constants_1.AUTH_STRATEGIES.WEB_8BASE:
        case constants_1.AUTH_STRATEGIES.WEB_AUTH0: {
            return web_auth0_auth_client_1.WebAuth0AuthClient;
        }
        case constants_1.AUTH_STRATEGIES.WEB_OAUTH: {
            return web_oauth_client_1.WebOAuthClient;
        }
        case constants_1.AUTH_STRATEGIES.WEB_COGNITO: {
            return web_cognito_auth_client_1.WebCognitoAuthClient;
        }
    }
};
class Auth {
    static createClient(options, clientOptions) {
        utils_1.throwIfMissingRequiredParameters(['strategy'], utils_1.PACKAGES.AUTH, options);
        utils_1.showWarningIfDeprecatedParameters(['storage', 'storageKey'], utils_1.PACKAGES.AUTH, options);
        const { strategy, subscribable } = options;
        const storageOptions = !!options.storageOptions
            ? options.storageOptions
            : {
                // @ts-ignore
                storage: options.storage,
                // @ts-ignore
                storageKey: options.storageKey,
            };
        const Constructor = getAuthClientConstructor(strategy);
        let authClient = new Constructor(clientOptions, storageOptions);
        if (subscribable) {
            authClient = SubscribableDecorator_1.SubscribableDecorator.decorate(authClient);
        }
        return authClient;
    }
}
exports.Auth = Auth;
//# sourceMappingURL=Auth.js.map